import { useTheme } from '@material-ui/core/styles'

interface IStatus {
  [key: string]: {
    text: string,
    color: string
  }
}

const useCriticality = () : IStatus => {
  const theme = useTheme()

  return {
    LOW: { text: 'Baixa', color: theme.palette.info.light },
    HIGH: { text: 'Alta', color: theme.palette.warning.dark },
    IN_ANALYSIS: { text: 'Em Análise', color: theme.palette.info.dark }
  }
}

export default useCriticality
